/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * A domain associated with a banner
 */
export type BannerTag = (typeof BannerTag)[keyof typeof BannerTag]

export const BannerTag = {
  home: "home",
  usage: "usage",
} as const
